import type { RouteObject } from "react-router-dom";
import NotFound from "../pages/NotFound";
import Home from "../pages/home/page";
import PoliticaPrivacidade from "../pages/politica-de-privacidade/page";

const routes: RouteObject[] = [
  {
    path: "/",
    element: <Home />,
  },
  {
    path: "/politica-de-privacidade",
    element: <PoliticaPrivacidade />,
  },
  {
    path: "*",
    element: <NotFound />,
  },
];

export default routes;
